'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dPresto$0024$0024anon$002411 from "./presto.-Presto$$anon$11.js";
import * as $j_presto$002e$002dPresto$0024$0024anon$00249 from "./presto.-Presto$$anon$9.js";
import * as $j_presto$002etypes$0024$002dCompact$002dPlan$0024 from "./presto.types$-Compact-Plan$.js";
import * as $j_presto$002etypes$0024$002dPlan$002dCode$0024 from "./presto.types$-Plan-Code$.js";
var $p;
/** @constructor */
function $c_Lpresto_Presto$$anon$8() {
  this.bdb = null;
  this.bd3 = null;
  this.bd4 = false;
  this.bdc = null;
  this.bdd = false;
  this.bdg = null;
  this.bd9 = null;
  this.bda = false;
  this.bd5 = null;
  this.bd6 = false;
  this.bd7 = null;
  this.bd8 = false;
  this.bde = false;
  this.bdf = false;
  this.bdb = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bdg = "CompactPlan";
}
export { $c_Lpresto_Presto$$anon$8 as $c_Lpresto_Presto$$anon$8 };
$p = $c_Lpresto_Presto$$anon$8.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_Presto$$anon$8;
/** @constructor */
function $h_Lpresto_Presto$$anon$8() {
}
export { $h_Lpresto_Presto$$anon$8 as $h_Lpresto_Presto$$anon$8 };
$h_Lpresto_Presto$$anon$8.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.K = (function() {
  return this.bdb;
});
$p.M = (function() {
  if ((!this.bd4)) {
    this.bd3 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bd4 = true;
  }
  return this.bd3;
});
$p.O = (function() {
  if ((!this.bdd)) {
    this.bdc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bdd = true;
  }
  return this.bdc;
});
$p.D = (function() {
  return this.bdg;
});
$p.t = (function() {
  if ((!this.bda)) {
    this.bd9 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("code", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("features", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.bda = true;
  }
  return this.bd9;
});
$p.N = (function() {
  if ((!this.bd6)) {
    this.bd5 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dPlan$002dCode$0024.$m_Lpresto_types$PlanCode$().ae1(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$$anon$44(new $j_presto$002e$002dPresto$0024$0024anon$00249.$c_Lpresto_Presto$$anon$9())), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.bd6 = true;
  }
  return this.bd5;
});
$p.Q = (function() {
  if ((!this.bd8)) {
    this.bd7 = new $j_presto$002e$002dPresto$0024$0024anon$002411.$c_Lpresto_Presto$$anon$11();
    this.bd8 = true;
  }
  return this.bd7;
});
$p.v = (function() {
  if ((!this.bdf)) {
    this.bde = false;
    this.bdf = true;
  }
  return this.bde;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee74) => ((p) => \u03b4scrutinee74.adG(p)))($j_presto$002etypes$0024$002dCompact$002dPlan$0024.$m_Lpresto_types$CompactPlan$())));
});
var $d_Lpresto_Presto$$anon$8 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_Presto$$anon$8, "presto.Presto$$anon$8", ({
  Nr: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_Presto$$anon$8 as $d_Lpresto_Presto$$anon$8 };
//# sourceMappingURL=presto.-Presto$$anon$8.js.map
